/*!
 *  Engine      : PublicAddressEngine
 *  Component   : Address
----------------------------------------------------------------------------- */

(function (window, angular, undefined) {

	'use strict';

	/*
	  Public Address Engine
	  -------------------------------------------------------------------------- */

	angular.module('PublicApp.address', [])

		/**
    	  * AddressListController for list of address
    	  *
    	  * @inject __Utils
    	  * @inject __Form
    	  * @inject $state
    	  * @inject appServices
    	  * 
    	  * @return void
    	 *-------------------------------------------------------- */

		.controller('AddressListController', [
			'__Utils',
			'__Form',
			'$state',
			'appServices',
			'$scope',
			'__Auth',
			'__DataStore',
			'$rootScope',
			function (__Utils, __Form, $state, appServices, $scope, __Auth, __DataStore, $rootScope) {

				var scope = this;
				scope = __Form.setup(scope, 'user_address_form', 'addressData');
				scope.pageStatus = false;
				scope.addressData = {};

				/**
		          * get List of addresses
		          *
		          * @return void
		          *---------------------------------------------------------------- */
				scope.getAddresses = function () {

					__DataStore.fetch('user.get.addresses')
						.success(function (responseData) {

							appServices.processResponse(responseData, null,
								function () {
									var requestData = responseData.data;
									scope.addressData = requestData;
									scope.pageStatus = true;

								});
						});
				};
				scope.getAddresses();

		        /**
		          * Delete address 
		          *
		          * @param number addressID
		          *
		          * @return void
		          *---------------------------------------------------------------- */
				scope.delete = function (addressID) {

					__globals.showConfirmation({
						text: __globals.getJSString('address_delete_text'),
						confirmButtonText: __globals.getJSString('delete_action_button_text')
					},
						function () {

							__DataStore.post({
								'apiURL': 'user.address.delete',
								'addressID': addressID,
							})
								.success(function (responseData) {

									var message = responseData.data.message;

									appServices.processResponse(responseData, {
										error: function (data) {
											__globals.showConfirmation({
												title: __globals.getJSString('confirm_error_title'),
												text: message,
												type: 'error'
											});

										}
									},
										function (data) {

											__globals.showConfirmation({
												title: __globals.getJSString('confirm_error_title'),
												text: message,
												type: 'success'
											});

											// use for slowly remove address from list
											$('#address_' + addressID).fadeOut('slow', function () {
												$(this).remove();
												scope.getAddresses();
											});

										}
									);

								});

						});

				};

				$rootScope.$on('lw.login-success', function (event, data) {

					if (data) {
						scope.getAddresses();
					}
				});

		        /**
		          * address add dialog
		          *
		          * @param number pageType
		          *
		          * @return void
		          *---------------------------------------------------------------- */
				scope.addAddressDialog = function () {

					scope.addressType = scope.addressData.addressType;
					scope.countries = scope.addressData.countries.data;
					appServices.showDialog(scope,
						{
							templateUrl: __globals.getTemplateURL(
								'address.add'
							)
						}, function (promiseObj) {

							if (_.has(promiseObj.value, 'address_added')
								&& promiseObj.value.address_added === true) {
								scope.getAddresses();
							}

						});
				}


		        /**
		          * address edit dialog
		          *
		          * @param number addressID
		          *
		          * @return void
		          *---------------------------------------------------------------- */
				scope.editAddressDialog = function (addressID) {

					__DataStore.fetch({
						'apiURL': 'user.fetch.address.support.data',
						'addressID': addressID
					})
						.success(function (responseData) {

							scope.countries = responseData.data.countries;
							scope.address = responseData.data.address;
							scope.addressType = responseData.data.addressType;

							appServices.showDialog(scope,
								{
									templateUrl: __globals.getTemplateURL(
										'address.edit'
									)
								}, function (promiseObj) {

									if (_.has(promiseObj.value, 'address_updated')
										&& promiseObj.value.address_updated == true) {
										scope.getAddresses();
									}

								});

						});
				}

		        /**
		          * address list dialog
		          *
		          * @return void
		          *---------------------------------------------------------------- */
				scope.addressListDialog = function () {

					__DataStore.fetch({ 'apiURL': 'get.addresses.for.order' })
						.success(function (responseData) {

							var requestData = responseData.data;
							scope.addressData = requestData;

							appServices.showDialog(requestData,
								{
									templateUrl: __globals.getTemplateURL(
										'address.list-dialog'
									)
								},
								function (promiseObj) {

								});
						});
				}

		        /**
		          * Close dialog
		          *
		          * @return void
		          *---------------------------------------------------------------- */

				scope.close = function () {
					$scope.closeThisDialog();
				}

		        /**
		          * Select address for order
		          *
		          * @return void
		          *---------------------------------------------------------------- */

				scope.selectAddressForOrder = function (addressData, selectedAddress) {

					// get address for order by address ID
					if (!_.isEmpty(addressData)) {

						_.forEach(addressData, function (address, key) {

							// take primary address
							if (address.id == selectedAddress) {

								$scope.closeThisDialog({ 'selectedAddress': address });

							}

						});

					} else {

						$scope.closeThisDialog({ 'selectedAddress': '' });
					}
				}

		        /**
		          * Make primary address
		          *
		          * @return void
		          *---------------------------------------------------------------- */

				scope.makePrimaryAddress = function (addressID) {

					__Form.process({
						'apiURL': 'user.get primary.address',
						'addressID': addressID
					}, scope)
						.success(function (responseData) {

							var message = responseData.data.message;

							appServices.processResponse(responseData, null,
								function () {

									scope.getAddresses();
								}
							);

						});
				}

			}
		])


    	/**
    	  * AddressAddController for add new address
    	  *
    	  * @inject $scope
    	  * @inject __Form
    	  * @inject appServices
    	  * 
    	  * @return void
    	 *-------------------------------------------------------- */

		.controller('AddressAddController', [
			'$scope',
			'__Auth',
			'__Form',
			'appServices',
			function ($scope, __Auth, __Form, appServices) {

				var scope = this;
				scope = __Form.setup(scope, 'user_address_form', 'userData', {
					secured: false
				});

				scope.ngDialogData = $scope.ngDialogData.addressData;

				// Get address type
				scope.addressType = scope.ngDialogData.addressType;


				// Get countries List
				scope.countriesCollection = scope.ngDialogData.countries.data;
				scope.countries = scope.countriesCollection.countries;

				scope.countries_select_config = __globals.getSelectizeOptions({
					valueField: 'value',
					labelField: 'text',
					searchField: ['text']
				});


		        /**
		          * Submit address form action
		          *
		          * @return void
		          *---------------------------------------------------------------- */

				scope.submit = function () {

					__Form.process('user.address.process', scope)

						.success(function (responseData) {

							appServices.processResponse(responseData, null, function () {

								$scope.closeThisDialog({ address_added: true })

							});
						});

				};

	            /**
		          * Close dialog
		          *
		          * @return void
		          *---------------------------------------------------------------- */

				scope.close = function () {
					$scope.closeThisDialog();
				}
			}
		])


        /**
    	  * AddressEditController for add new address
    	  *
    	  * @inject $scope
    	  * @inject __Form
    	  * @inject appServices
    	  * 
    	  * @return void
    	 *-------------------------------------------------------- */

		.controller('AddressEditController', [
			'$scope',
			'__Form',
			'appServices',
			function ($scope, __Form, appServices) {

				var scope = this;
				scope = __Form.setup(scope, 'user_address_edit_form', 'addressData');

				// Get address type
				scope.addressType = $scope.ngDialogData.addressType;

				// Get address Data
				scope.addressData = $scope.ngDialogData.address;

				// Get all countries
				scope.countriesCollection = $scope.ngDialogData.countries.data;
				scope.countries = scope.countriesCollection.countries;

				scope.countries_select_config = __globals.getSelectizeOptions({
					valueField: 'value',
					labelField: 'text',
					searchField: ['text']
				});


		        /**
		          * update form action
		          *
		          * @return void
		          *------------------------------------------------------------------------ */

				scope.update = function () {

					scope.updateURL = {
						'apiURL': 'user.address.update',
						'addressID': scope.addressData.id
					};

					// post form data
					__Form.process(scope.updateURL, scope)

						.success(function (responseData) {

							appServices.processResponse(responseData, null, function (reactionCode) {

								$scope.closeThisDialog({ address_updated: true })

							});

						});

				};

	            /**
		          * Close dialog
		          *
		          * @return void
		          *---------------------------------------------------------------- */

				scope.close = function () {
					$scope.closeThisDialog();
				}
			}
		])




})(window, window.angular);